import { LinkPage } from "../types/Link";

class LocalStorageAPI {
  private static storageKey = "linkPages";

  private static initialLinkPages: LinkPage[] = [
    {
      Name: "Search Engines (an example)",
      Stub: "example-search-engines",
      Description: "A list of search engines.",
      Owner: "george",
      DefaultVariableValues: {
        query: "alpaca",
      },
      Links: [
        {
          Name: "Google",
          URL: "https://www.google.com/search?q={{query}}",
          CreatedAt: "2023-05-07T17:20:58.399Z",
        },
        {
          Name: "You.com",
          URL: "https://you.com/search?q={{query}}",
          CreatedAt: "2023-05-07T17:21:16.583Z",
        },
        {
          Name: "DuckDuckGo",
          URL: "https://duckduckgo.com/?q={{query}}",
          CreatedAt: "2023-05-07T17:21:49.411Z",
        },
        {
          Name: "Yahoo",
          URL: "https://uk.search.yahoo.com/search?p={{query}}",
          CreatedAt: "2023-05-08T14:14:40.825Z",
        },
      ],
    },
  ];

  private static initialiseLocalStorage(): void {
    if (localStorage.getItem(this.storageKey)) {
      return;
    }
    localStorage.setItem(
      this.storageKey,
      JSON.stringify(LocalStorageAPI.initialLinkPages)
    );
  }

  public static upsertLinkPage(linkPage: LinkPage): LinkPage {
    return this.updateLinkPage(linkPage) || this.createLinkPage(linkPage);
  }

  public static createLinkPage(linkPage: LinkPage): LinkPage {
    const linkPages: LinkPage[] = this.getLinkPages();
    linkPages.push(linkPage);
    localStorage.setItem(this.storageKey, JSON.stringify(linkPages));
    return linkPage;
  }

  public static getLinkPages(): LinkPage[] {
    LocalStorageAPI.initialiseLocalStorage();

    const rawData = localStorage.getItem(this.storageKey);
    return rawData ? JSON.parse(rawData) : [];
  }

  public static getLinkPageById(stub: string): LinkPage | null {
    const linkPages = this.getLinkPages();
    return linkPages.find((linkPage) => linkPage.Stub === stub) || null;
  }

  public static updateLinkPage(updatedLinkPage: LinkPage): LinkPage | null {
    const linkPages = this.getLinkPages();
    const index = linkPages.findIndex(
      (linkPage) => linkPage.Stub === updatedLinkPage.Stub
    );
    if (index === -1) return null;
    linkPages[index] = updatedLinkPage;
    localStorage.setItem(this.storageKey, JSON.stringify(linkPages));
    return updatedLinkPage;
  }

  public static deleteLinkPage(stub: string): boolean {
    const linkPages = this.getLinkPages();
    const index = linkPages.findIndex((linkPage) => linkPage.Stub === stub);
    if (index === -1) return false;
    linkPages.splice(index, 1);
    localStorage.setItem(this.storageKey, JSON.stringify(linkPages));
    return true;
  }
}

export default LocalStorageAPI;
